export default {"src":"/_next/static/media/emptyData.df54fb34.svg","height":34,"width":40};